import { tv, VariantProps } from '@/utils/tv'

export const input = tv({
  slots: {
    base: ['relative', 'w-full', 'flex flex-col'],
    label: ['mb-2'],
    group: ['relative', 'flex items-center gap-x-2'],
    input: [
      'block',
      'w-full',
      'py-3 px-4',
      'appearance-none',
      'outline-none',
      'placeholder:text-gray-600'
    ],
    icon: ['flex pointer-events-none h-5 outline-none']
  },
  variants: {
    color: {
      dark: {
        icon: 'text-gray-400',
        label: 'text-gray-400'
      },
      light: ''
    },
    appearance: {
      outline: {
        input: [
          'border-gray-200',
          'bg-white',
          'focus:border-blue-400 focus:ring focus:ring-blue-100'
        ],
        icon: ['absolute inset-y-0 m-auto']
      },
      ghost: {
        input: [
          'px-0',
          'bg-transparent border-transparent',
          'focus:outline-none focus:border-transparent focus:ring-0'
        ]
      }
    },
    hasError: {
      true: ''
    },
    hasStartContent: {
      true: ''
    },
    hasEndContent: {
      true: ''
    }
  },
  defaultVariants: {
    appearance: 'outline',
    color: 'dark',
    hasError: false
  },
  compoundVariants: [
    {
      appearance: 'outline',
      hasError: true,
      className: {
        input: ['border-red-500', 'focus:border-red-400 focus:ring-red-100']
      }
    },
    {
      appearance: 'outline',
      hasStartContent: true,
      className: {
        input: ['pl-10'],
        icon: []
      }
    },
    {
      appearance: 'outline',
      hasEndContent: true,
      className: {
        input: ['pr-10'],
        icon: []
      }
    }
  ],
  compoundSlots: [
    {
      slots: ['icon', 'label', 'input'],
      hasError: true,
      className: 'text-red-500'
    }
  ]
})

export type InputVariantProps = Omit<
  VariantProps<typeof input>,
  'hasStartContent' | 'hasEndContent' | 'hasError'
>
